import clsx from 'clsx'
import CodeViewer from 'components/CodeViewer/CodeViewer'
import { formatJSON } from 'helpers/format'
import { BoxIcon } from 'lucide-react'
import { IdEventV4 } from 'models/event'

import { IdentificationUrlKeys } from '../../../types'
import { SmartSignalDefinition } from './SmartSignalRepresentation'

export const virtualMachineDefinition: SmartSignalDefinition<{ virtual_machine?: IdEventV4['virtual_machine'] }> = {
  key: 'virtual-machine',
  label: 'Virtual machine',
  extract: (e) => ({ virtual_machine: e.virtual_machine }),
  icon(e) {
    const p = this.extract(e)?.virtual_machine

    return (
      <BoxIcon
        className={clsx('size-4', {
          'text-red-800': p,
        })}
      />
    )
  },
  details(e) {
    return (
      <CodeViewer
        value={formatJSON(this.extract(e))}
        withSearch={false}
        className={this.isDetected(e) ? 'bg-red-100 border-red-300' : 'bg-gray-100'}
      />
    )
  },
  isDetected(e) {
    const p = this.extract(e)?.virtual_machine
    return p === true
  },
  isWeb: () => true,
  isMobile: () => false,
  searchFor: '"virtual_machine":',
  documentationHash: '#virtual-machine-detection',
  urlParamKey: IdentificationUrlKeys.VirtualMachine,
}
